import ApiService from './service';
import * as http from './http';
import { stringify } from 'query-string';

export class ZohoService extends ApiService {

    async getZohoToken() {
        const url = `${this.apiDomain}/api/zoho`;

        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        // return { data: response.data };
        return response.data;
    }

    async getZohoEmployee() {
        const url = `${this.apiDomain}/api/zoho/employee`;

        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return response.data;
    }

    async getNewHires(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return response.data;
    }

    async getEmployeeByEmail(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

    async getAllEmployees(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }
    async getAllEmployeesWSRRate(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }
    async getWSREmployeesWithAccount(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

    async getEmployessByReport(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

    async getEmployeeAttendence(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

    async getClientSummary(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

    async getAnniversaryEmployees(request) {
        const {resource} = request;
        const url = `${this.apiDomain}/${resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }
    async getEmployeesByBirthday(request) {
        const {resource} = request;
        const url = `${this.apiDomain}/${resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }
    async getHolidays(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

    async getLocation(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

    async checkInOut(request, data) {
        const url = `${this.apiDomain}/${request.resource}`;
        return http.post(url, data, this.store);
    }

    async getEmployessCountByBusinessUnit(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

    async getEmployessCountByPrimaryDept(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

    async getActiveEmployessCount(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }
    async getNewEmployessCount(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }
    async getResignedEmployeesCount(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }
    async getExitEmployeesCount(request) {
        const { startDate, endDate, allFlag } = request;
        const query = {
            startDate,
            endDate,
            allFlag
        };
        const url = `${this.apiDomain}/${request.resource}?${stringify(query)}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }
    async getEmployessCountByPrimaryDepartment(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

    async getEmployessByBusinessUnit(request) {
        const { limit, currentPage, search, sort, filter, user } = request;
        const query = {
            search,
            limit,
            sort: JSON.stringify(sort),
            filter: JSON.stringify(filter),
            page: currentPage,
            user,
        };

        if (!search) {
            delete query.search;
        }

        const url = `${this.apiDomain}/${request.resource}?${stringify(query)}`;

        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

    async downloadEmployeesByBusinessUnitsCSV(request) {
        const { search, filter } = request;
        const query = {
            search,
            filter: JSON.stringify(filter),
        };

        if (!search) {
            delete query.search;
        }

        const url = `${this.apiDomain}/${request.resource}?${stringify(query)}`;

        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

    async downloadAllEmployeesCSV(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

    async getAllEmployeesByPrimaryDepts(request) {
        const { limit, currentPage, search, sort, filter, user } = request;
        const query = {
            search,
            limit,
            sort: JSON.stringify(sort),
            filter: JSON.stringify(filter),
            page: currentPage,
            user,
        };

        if (!search) {
            delete query.search;
        }

        const url = `${this.apiDomain}/${request.resource}?${stringify(query)}`;

        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

    async getEmployessByPrimaryDept(request) {
        const { limit, currentPage, search, sort, filter, user } = request;
        const query = {
            search,
            limit,
            sort: JSON.stringify(sort),
            filter: JSON.stringify(filter),
            page: currentPage,
            user,
        };

        if (!search) {
            delete query.search;
        }

        const url = `${this.apiDomain}/${request.resource}?${stringify(query)}`;

        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

    async getAllResignedEmployess(request) {
        const { limit, currentPage, search, sort, user } = request;
        const query = {
            search,
            limit,
            sort: JSON.stringify(sort),
            page: currentPage,
            user,
        };

        if (!search) {
            delete query.search;
        }

        const url = `${this.apiDomain}/${request.resource}?${stringify(query)}`;

        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

    async getAllActiveEmployes() {
        const url = `${this.apiDomain}/api/zoho/getAllActiveEmployess`;
        try {
            const response = await http.get(url, this.store);
            // Directly return the 'details' array as it holds the employee data
            return response?.data || [];
        } catch (err) {
            console.error("❌ Error while fetching active employees:", err);
            throw err;
        }
    }



    async getAllExitEmployess(request) {
        const { limit, currentPage, search, sort, user, startDate, endDate, allFlag } = request;
        const query = {
            search,
            limit,
            sort: JSON.stringify(sort),
            page: currentPage,
            user,
            startDate,
            endDate,
            allFlag
        };

        if (!search) {
            delete query.search;
        }

        const url = `${this.apiDomain}/${request.resource}?${stringify(query)}`;

        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

    async downloadCSV(request) {
        const { startDate, endDate, allFlag } = request;
        const query = {
            startDate,
            endDate,
            allFlag
        };
        const url = `${this.apiDomain}/${request.resource}?${stringify(query)}`;
        const response = await http
            .get(url, this.store)
            .catch((err) => console.log(err));
        return { data: response.data };
    }

}